// Footer.tsx
import {
  Box,
  Flex,
  Text,
  HStack,
  Image,
  Link,
  IconButton,
  VStack
} from '@chakra-ui/react'
import {
  FaFacebookF,
  FaDiscord,
  FaYoutube,
  FaRegNewspaper,
  FaTelegram
} from 'react-icons/fa'
import { EmailIcon } from '@chakra-ui/icons'

const Footer = () => {
  return (
    <Box bg="#e6e7ef" py={10} px={4}>
      <Flex
        maxW="6xl"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
      >
        {/* 좌측 로고 및 소셜 아이콘 */}
        <VStack align="start" spacing={4}>
          <HStack spacing={3}>
            <Image src="/images/logo/logo.png" alt="Logo" h="28px" />
            <IconButton
              as="a"
              href="https://www.youtube.com/@%EB%A6%AC%EC%8A%A4%ED%83%80%ED%8A%B8%ED%94%BC%ED%94%8C"
              target="_blank"
              rel="noopener noreferrer"
              icon={<FaYoutube />}
              aria-label="youtube"
              variant="ghost"
              color="gray.600"
              isRound
            />
            <IconButton
              as="a"
              href="https://t.me/+PuVi5csjDzsyNmZl"
              target="_blank"
              rel="noopener noreferrer"
              icon={<FaTelegram />}
              aria-label="youtube"
              variant="ghost"
              color="gray.600"
              isRound
            />
          </HStack>
        </VStack>

        {/* 우측 정보 */}
        <Box mt={{ base: 8, md: 0 }} color="gray.500" fontSize="sm">
          <Text>Copyright © 2025 xrplay. All rights reserved.</Text>
        </Box>
      </Flex>
    </Box>
  )
}

export default Footer
